import { useQuery } from '@tanstack/react-query';
import { API } from '@src/api/index.ts';
import { EntityByIdParam } from '@src/api/types.ts';

export const useCoachQuery = (params: EntityByIdParam) => {
  return useQuery({
    queryKey: ['coach', params.id],
    queryFn: async () => await API.coaches.getById(params),
    enabled: typeof params?.id !== 'undefined',
  });
};
